import { getAnchorPlugin } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

/* START OF COMPILED CODE */

import LoadingSpinner from './LoadingSpinner';
import UIBlocker from './UIBlocker';

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class LoadingContainer extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // uIBlocker_1
    const uIBlocker_1 = new UIBlocker(scene, 0, 0);
    this.add(uIBlocker_1);

    // loadingSpinner
    const loadingSpinner = new LoadingSpinner(scene, 0, 0);
    this.add(loadingSpinner);

    this.loadingSpinner = loadingSpinner;

    /* START-USER-CTR-CODE */
    this.create();
    /* END-USER-CTR-CODE */
  }

  private loadingSpinner: LoadingSpinner;

  /* START-USER-CODE */

  create() {
    const anchor = getAnchorPlugin(this.scene);
    anchor.add(this.loadingSpinner, { centerX: '50%', centerY: '50%' });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
